// CountriesData.js
const countriesData = [
  { id: '1', position: "-61.5137, 10.6718", label: 'Trinidad and Tobago', logo:'/gttd.png' },
  { id: '111', position: "-61.5137, 10.6718", label: 'Trinidad and Tobago', logo:'/gttd.png' },
  { id: '112', position: "-61.5137, 10.6718", label: 'Trinidad and Tobago', logo:'/gttd.png' },
  { id: '113', position: "-61.5137, 10.6718", label: 'Trinidad and Tobago', logo:'/gttd.png' },
  { id: '114', position: "-59.6101, 13.0935", label: 'Barbados', logo:'/gttd.png' },
  { id: '2', position: "-59.6101, 13.0935", label: 'Barbados', logo:'/gttd.png' },
  { id: '3', position: "-90.5069, 14.6349", label: 'Guatemala', logo:'/gttd.png' },
  { id: '4', position: "-0.1276, 51.5072", label: 'United Kingdom', logo:'/gttd.png' },
  { id: '5', position: "35.2137, 31.7683", label: 'Israel', logo:'/gttd.png' },
  { id: '6', position: "121.5654, 25.0330", label: 'Taiwan', logo:'/gttd.png' },
  { id: '7', position: "126.9780, 37.5665", label: 'South Korea', logo:'/gttd.png' },
  { id: '8', position: "-77.0369, 38.9072", label: 'USA', logo:'/gttd.png' },
  { id: '9', position: "-99.1332, 19.4326", label: 'Mexico', logo:'/gttd.png' },
  { id: '10', position: "-3.7038, 40.4168", label: 'Spain', logo:'/gttd.png' },
  { id: '11', position: "12.5683, 55.6761", label: 'Denmark', logo:'/gttd.png' },
  { id: '12', position: "7.4474, 46.9480", label: 'Switzerland', logo:'/gttd.png' },
  { id: '13', position: "31.2357, 30.0444", label: 'Egypt', logo:'/gttd.png' },
  { id: '14', position: "4.8952, 52.3702", label: 'Netherlands', logo:'/gttd.png' },
  { id: '15', position: "13.4050, 52.5200", label: 'Germany', logo:'/gttd.png' },
  { id: '16', position: "101.6869, 3.1390", label: 'Malaysia', logo:'/gttd.png' },
  { id: '17', position: "100.5167, 13.7563", label: 'Thailand', logo:'/gttd.png' },
  { id: '18', position: "104.9160, 11.5564", label: 'Cambodia', logo:'/gttd.png' },
  { id: '19', position: "-9.1427, 38.7223", label: 'Portugal', logo:'/gttd.png' },
  { id: '20', position: "51.5310, 25.2854", label: 'Qatar', logo:'/gttd.png' },
  { id: '21', position: "85.3240, 27.7172", label: 'Nepal', logo:'/gttd.png' },
  { id: '214', position: "85.3240, 27.7172", label: 'Nepal', logo:'/gttd.png' },
  { id: '22', position: "106.8456, -6.2088", label: 'Indonesia', logo:'/gttd.png' },
  { id: '23', position: "103.8198, 1.3521", label: 'Singapore', logo:'/gttd.png' },
  { id: '24', position: "44.7833, 41.7151", label: 'Georgia', logo:'/gttd.png' },
  { id: '25', position: "2.3522, 48.8566", label: 'France', logo:'/gttd.png' },
  { id: '26', position: "-84.0739, 9.7489", label: 'Costa Rica', logo:'/gttd.png' },
  { id: '27', position: "-74.0721, 4.7110", label: 'Colombia', logo:'/gttd.png' },
  { id: '28', position: "-78.4678, -0.1807", label: 'Ecuador', logo:'/gttd.png' },
  { id: '29', position: "-77.0428, -12.0464", label: 'Peru', logo:'/gttd.png' },
  { id: '30', position: "120.9842, 14.5995", label: 'Philippines', logo:'/gttd.png' },
  { id: '31', position: "108.2772, 14.0583", label: 'Vietnam', logo:'/gttd.png' },
  { id: '32', position: "77.2090, 28.6139", label: 'India', logo:'/gttd.png' },
  { id: '33', position: "28.9784, 41.0082", label: 'Turkiye', logo:'/gttd.png' },
  { id: '34', position: "19.8187, 41.3275", label: 'Albania', logo:'/gttd.png' },
];

export default countriesData;
